import { Enum } from 'enumify';

export default class FileType extends Enum {}
FileType.initEnum([
  'DIRECTORY',
  'FILE',
]);



// WEBPACK FOOTER //
// ./src/routes/asset/FileType.js